import { dismissOutcomes, useOnline, useOutbox } from './offline';

/** What the phone is doing with your changes: offline, waiting to send, or how sends turned out. */
export function Status() {
  const { waiting, outcomes } = useOutbox();
  const online = useOnline();
  return (
    <div className="p-status">
      {!online && (
        <p role="status" className="notice">
          You are offline. You can keep working; changes are saved on this phone and sent when you
          have a signal.
        </p>
      )}
      {waiting > 0 && (
        <p role="status" className="notice">
          {waiting === 1 ? '1 change is' : `${waiting} changes are`} waiting to send.
        </p>
      )}
      {outcomes.length > 0 && (
        <div role="status" className="notice">
          <ul>
            {outcomes.map((o) => (
              <li key={o.key} className={o.ok ? '' : 'error'}>
                {o.label}: {o.ok ? 'sent.' : `not done. ${o.message}`}
              </li>
            ))}
          </ul>
          <button type="button" className="quiet" onClick={dismissOutcomes}>
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
}
